import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '新潟県シンボル普及促進アンバサダー | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="新潟県シンボル普及促進アンバサダー" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2024夏号 No.167 目次",
              path: "/no167"
            },
            {
              name: "新潟県シンボル普及促進アンバサダー"
            }
          ]}
        />
        
        <p>新潟県の6つのシンボルの魅力をアンバサダーから聞いてみませんか。</p>
        
        <img
          src={`${basePath}/no167/img/4-6.png`}
          alt="県の木「雪椿」アンバサダーによる小学生向けの活動の様子"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>県の木「雪椿」アンバサダーによる小学生向けの活動の様子</p>
        
        <p>県では、チューリップ、トキ、雪椿、雪割草、錦鯉、ヒスイを新潟県を象徴する6つのシンボルとして定めています。<br />専門知識をもったアンバサダーがそれらシンボルの特徴や歴史、ストーリーなどを分かりやすく解説します。</p>
        
        <p>学校や自治会、団体などのグループでお気軽にお申し込みください</p>
        
        <p css={style.notetTxt}>＊アンバサダーの活動の謝礼金は県が負担しますが、現地までの交通費等の経費については申込者からご負担いただきます。</p>
        
        
        <p>詳細と申込は
          <a
            href="https://www.pref.niigata.lg.jp/sec/kouhou/symbolambassadordemae.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
